import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddonsMarket } from '@wix/editor-platform-host-integration/ui';

import { connectWithScope } from '@/apilib';
import { frames } from '@/panels';

import platformConsts from '../common/constants';
import { AddonsScope } from './scope';
import { EditorPlatformHostIntegrationAPI } from '@wix/editor-platform-host-integration-apis';
import {
  EditorType,
  InstallInitiator,
  InstallationOriginType,
} from '@wix/platform-editor-sdk';
type Props = ReturnType<typeof mapDispatchToProps>;

const AddonsPanelComponent = (props: Props) => {
  const [t] = useTranslation();

  return (
    <frames.TpaSettingsPanelFrame
      panelName={platformConsts.panelTypes.ADDONS_MARKET}
      title={t('PLATFORM_addons_panel_title')}
      onClose={props.closePanel}
      style={{
        top: '60',
        left: '0',
        right: '0',
        width: 'fit-content',
        height: 'fit-content',
        margin: '0 auto',
        overflowX: 'visible',
      }}
      shouldAddScroll={false}
    >
      <AddonsMarket
        t={t}
        openAddonPanel={props.openAddonPanel}
        closeAddonPanel={props.closeAddonPanel}
        isInstalled={props.isInstalled}
        handleInstall={props.installAddon}
        handleUninstall={props.uninstallAddon}
        addonsToHide={[
          // Design guides
          '7f903d78-65fc-4b4c-8e29-eda31fb4e1a5',
          // Task list
          '14d6a2d6-a025-4207-9a0e-6933b5f429a0',
        ]}
      />
    </frames.TpaSettingsPanelFrame>
  );
};
export const mapDispatchToProps = ({
  editorAPI,
  addonsPrivateApi,
}: AddonsScope) => {
  const platformAPI = editorAPI.host.getAPI(EditorPlatformHostIntegrationAPI);

  const uninstallAddon = async (appDefinitionId: string) => {
    const appData = editorAPI.platform.getAppDataByAppDefId(appDefinitionId);
    await editorAPI.platform.applications.uninstall(appData);
  };

  return {
    closePanel: addonsPrivateApi.closeAddonsMarketPanel,
    installAddon: async (appDefinitionId: string) => {
      await platformAPI.addons.install(appDefinitionId, {
        origin: {
          type: EditorType.Classic,
          initiator: InstallInitiator.Editor,
          info: {
            type: InstallationOriginType.ADDONS_MARKET,
          },
        },
      });
      addonsPrivateApi.closeAddonsMarketPanel();
    },
    uninstallAddon,
    openAddonPanel: addonsPrivateApi.openAddonToolPanel,
    closeAddonPanel: addonsPrivateApi.closeAddonToolPanel,
    isInstalled: editorAPI.platform.isAppActive,
  };
};

export const AddonsPanel = connectWithScope(
  () => AddonsScope,
  AddonsPanelComponent,
  null,
  mapDispatchToProps,
);
